
const handleSmoothScroll = () => {
    const drawer = document.querySelector('#custom-cart-drawer');
    if (!drawer) {
      console.log("Cart drawer not found");
      return;
    }
  
    drawer.addEventListener('click', (e) => {
      const priceDetailsLink = e.target.closest('a[href="#price_section"]');
      if (!priceDetailsLink) {
        return;
      }
  
      e.preventDefault();
  
      const targetSection = drawer.querySelector('#price_section');
      if (!targetSection) {
        console.log("Target section '#price_section' not found within the drawer");
        return;
      }
  
      const header = drawer.querySelector('.custom-drawer__header');
      const headerHeight = header ? header.offsetHeight : 0;
  
      const targetPosition = targetSection.offsetTop - headerHeight - 20; // 20px padding
  
      drawer.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    });
  };
  // const addToCart = async (formData) => {
  //   try {
  //     const response = await fetch('/cart/add.js', {
  //       method: 'POST',
  //       body: formData,
  //     });
  
  //     if (!response.ok) throw new Error('Add to cart failed');
  
  //     const data = await response.json();
  
  //     const productName = data.title || data.product_title || 'Product'; 
  //     const productImage = data.image || (data.featured_image && data.featured_image.url) || '/path/to/default/image.jpg'; 
  
  //     const event = new CustomEvent('cart:added', {
  //       detail: {
  //         name: productName,
  //         image: productImage,
  //       },
  //     });
  //     document.dispatchEvent(event);
  
  //     return data;
  //   } catch (error) {
  //     handleFetchError(error);
  //   }
  // };
  
  // const getCartData = async () => {
  //   try {
  //     const response = await fetch('/cart.js');
  //     if (!response.ok) throw new Error('Failed to fetch cart');
  //     return await response.json();
  //   } catch (error) {
  //     handleFetchError(error);
  //   }
  // };
  
  // const updateCartDrawer = async () => {
  //   try {
  
  //     const cartDrawerResponse = await fetch('/?section_id=custom-cart-drawer');
  //     const text = await cartDrawerResponse.text();
  
  //     const html = document.createElement('div');
  //     html.innerHTML = text;
  
  //     // Extract the cart drawer content
  //     const newCartDrawerContent = html.querySelector('#custom-cart-drawer').innerHTML;
  
  
  //     const existingDrawer = document.querySelector('#custom-cart-drawer');
  //     if (existingDrawer) {
  //       existingDrawer.innerHTML = newCartDrawerContent;
  //       console.log('Cart drawer updated');
  
  //       // initializeQuantityHandlers();
  //       initializeCartDrawer();
  
  //       updateNavbarCartCount();
  //     } else {
  //       console.error('Existing cart drawer element not found');
  //     }
  
  //   } catch (error) {
  //     console.error('Error updating cart drawer:', error);
  //     handleFetchError(error);
  //   }
  // };
  
  const toggleCartDrawer = (show = true) => {
    const drawer = document.getElementById('custom-cart-drawer');
    if (!drawer) {
      console.error('Cart drawer element not found');
    //   return;
    }
      // updateTotalPrice();

    if (show) {
      drawer.classList.remove('hidden');
      setTimeout(() => drawer.classList.add('active'), 10);
      document.body.style.overflow = 'hidden';
    } else {
      drawer.classList.remove('active');
      setTimeout(() => drawer.classList.add('hidden'), 300);
      document.body.style.overflow = '';
    }
  };
  
  // Function to handle quantity changes
  // const handleQuantityChange = async (itemId, newQuantity) => {
  //   try {
  //     console.log('Updating quantity for item ID:', itemId, 'New quantity:', newQuantity);
  //     const response = await fetch('/cart/change.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         id: itemId,
  //         quantity: newQuantity,
  //       }),
  //     });
  
  //     if (!response.ok) throw new Error('Failed to update quantity');
  //     await updateCartDrawer();
  
  //   } catch (error) {
  //     handleFetchError(error);
  //   }
  // };
  
  // const handleQuantityInput = async (input) => {
  //   const cartItem = input.closest('.cart-item');
  //   if (!cartItem) {
  //     console.error('Cart item container not found for quantity input');
  //     return;
  //   }
  
  //   const itemId = cartItem.dataset.id;
  //   const newQuantity = parseInt(input.value);
  
  //   if (isNaN(newQuantity) || newQuantity < 1) {
  //     input.value = 1;
  //     return;
  //   }
  
  //   try {
  //     await handleQuantityChange(itemId, newQuantity);
  //   } catch (error) {
  //     console.error('Failed to update quantity:', error);
  //   }
  // };
  
  // Function to update navbar's cart count
  // const updateNavbarCartCount = async () => {
  //   try {
  //     const response = await fetch('/cart.js');
  //     if (!response.ok) throw new Error('Failed to fetch cart data');
  //     const cart = await response.json();
      
  //     // Update ALL cart count badges
  //     const cartCountElements = document.querySelectorAll('.cart-count-badge');
      
  //     cartCountElements.forEach(element => {
  //       if (cart.item_count > 0) {
  //         element.textContent = cart.item_count;
  //         element.classList.remove('hidden');
  //       } else {
  //         element.classList.add('hidden');
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Error updating navbar cart count:', error);
  //   }
  // };
  
  const showAddToCartNotification = (name, image) => {
    const body = document.body;
  
  
    const existingNotification = body.querySelector('.add-to-cart-notification');
    if (existingNotification) {
      console.log("Notification already exists");
      existingNotification.remove();
    }
  
    const notificationHTML = `
      <div class="add-to-cart-notification" role="alert" aria-live="assertive">
        <img src="${image}" alt="${name}" class="notification-image">
        <div class="text-holder">
          <h4 class="font-tropiline text-black">Congratulations!</h4>
          <span class="notification-text font-tropiline text-black opacity-60">${name} has been added to your shopping cart.</span>
        </div>
        <button class="notification-close-btn" aria-label="Close Notification">&times;</button>
      </div>
    `;
  
    body.insertAdjacentHTML('beforeend', notificationHTML);
  
    const notification = body.querySelector('.add-to-cart-notification');
    const closeButton = notification.querySelector('.notification-close-btn');
  
    void notification.offsetWidth;
  
    
    notification.classList.add('show');
  
    closeButton.addEventListener('click', () => {
      hideAddToCartNotification();
    });
  
  };
  
  const hideAddToCartNotification = () => {
    const notification = document.querySelector('.add-to-cart-notification');
    if (notification) {
      notification.classList.remove('show');
      setTimeout(() => {
        notification.remove();
      }, 300); 
    }
  };
  
  // Listen for 'cart:added' Event
  document.addEventListener('cart:added', (e) => {
    const { name, image } = e.detail; // Correctly extract from e.detail
    showAddToCartNotification(name, image);
  });
  
  // Function to initialize quantity handlers
  const initializeQuantityHandlers = () => {
    const cartItems = document.querySelector('.cart-items');
    if (!cartItems) {
      console.log('Cart items container not found');
    //   return;
    }
  
    // Remove existing event listeners to prevent duplication
    const newCartItems = cartItems.cloneNode(true);
    cartItems.parentNode.replaceChild(newCartItems, cartItems);
  
    // Handle click events for quantity buttons
    newCartItems.addEventListener('click', async (e) => {
      console.log('Click event detected on cart items');
      const cartItem = e.target.closest('.cart-item');
      if (!cartItem) {
        console.log('No cart item found');
        return;
      }
  
      const itemId = cartItem.dataset.id;
      console.log('Item ID:', itemId);
      const quantityInput = cartItem.querySelector('input[type="number"]');
      if (!quantityInput) {
        console.log('Quantity input not found for item:', itemId);
        return;
      }
      let currentQuantity = parseInt(quantityInput.value);
  
      if (e.target.classList.contains('quantity-decrease')) {
        console.log('Decrease button clicked');
  
        if (currentQuantity === 1) {
  
          await handleQuantityChange(itemId, 0);
        } else {
   
          const newQuantity = currentQuantity - 1;
          quantityInput.value = newQuantity;
          await handleQuantityChange(itemId, newQuantity);
        }
  
      } else if (e.target.classList.contains('quantity-increase')) {
        console.log('Increase button clicked');
        const newQuantity = currentQuantity + 1;
        quantityInput.value = newQuantity;
        await handleQuantityChange(itemId, newQuantity);
      }
    });
  
  
    newCartItems.addEventListener('change', async (e) => {
      if (e.target.matches('input[type="number"]')) {
        console.log('Quantity input changed');
        await handleQuantityInput(e.target);
      }
    });
  };
  
  const initializeCartDrawer = () => {
    const closeButton = document.querySelector('.custom-drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => toggleCartDrawer(false));
    } else {
      console.warn('Close button not found');
    }
  
    const overlay = document.querySelector('.custom-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
  
        if (e.target === overlay) {
          toggleCartDrawer(false);
        }
      });
    } else {
      console.warn('Cart drawer overlay not found');
    }
  
    // Initialize remove item buttons if they exist
    document.querySelectorAll('.cart-item__remove').forEach((removeButton) => {
      removeButton.addEventListener('click', async (e) => {
        e.preventDefault();
        const cartItem = removeButton.closest('.cart-item');
        if (!cartItem) {
          console.log('Cart item not found for removal');
          return;
        }
        const itemId = cartItem.dataset.id;
        await handleQuantityChange(itemId, 0);
      });
    });
  };
  
  const handleFetchError = (error) => {
    console.error('Fetch error:', error);
  };
  
  const initializeCartCountOnLoad = async () => {
    // await updateNavbarCartCount();
  };
  
  function initializeCart() {
  
    document.querySelectorAll('.product-card').forEach(function (product) {
      const addButton = product.querySelector('.add-to-cart-btn');
      const variantIdElement = product.querySelector('.variant-id');
  
      if (addButton && variantIdElement) {
        addButton.addEventListener('click', async function (e) {
          e.preventDefault();
  
          const variantIdText = parseInt(variantIdElement.dataset.variantId || variantIdElement.textContent.trim());
          if (isNaN(variantIdText)) {
            console.error('Invalid variant ID:', variantIdElement.textContent);
            return;
          }
          const quantity = 1; 
  
          console.log('Variant ID:', variantIdText, 'Quantity:', quantity);
  
          const formData = new FormData();
          formData.append('id', variantIdText);
          formData.append('quantity', quantity);
  
          try {
            await addToCart(formData);
            await updateCartDrawer(); 
            toggleCartDrawer(true);   
          } catch (error) {
            console.error('Failed to add to cart:', error);
          }
        });
      } else {
        if (!addButton) {
          console.warn('Add to cart button not found in product:', product);
        }
        if (!variantIdElement) {
          console.warn('Variant ID element not found in product:', product);
        }
      }
    });
  
   



    // initializeQuantityHandlers();
    initializeCartDrawer();
    handleSmoothScroll();
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        toggleCartDrawer(false);
      }
    });
    initializeCartCountOnLoad();
  };



  // function updateTotalPrice(){
  //   fetch('/cart.js')
  //         .then(res => res.json()) 
  //       .then(data => {
  //     // Calculate and update the total price
  //     console.log("total is: ", data.total_price);
  //     const totalPrice = (data.total_price / 100).toFixed(2); // Convert from cents to currency format
  //     const cartTotalElement = document.getElementById('drawer-cart-total'); // Make sure this exists
  //     cartTotalElement.textContent = `₹${totalPrice}`;
  // });
  // }
  
  // window.addToCart = addToCart;
  window.toggleCartDrawer = toggleCartDrawer;
  // window.updateCartDrawer = updateCartDrawer;
  window.initializeCart = initializeCart;
  // window.updateNavbarCartCount = updateNavbarCartCount;
  
  document.addEventListener('DOMContentLoaded', () => {
    initializeCart();
  });
  